import { usePatientInfo } from 'infrastructure/hooks/patient/use-patient-info';
import BaseSelect from 'components/molecules/select/base';

import { getContactOptions } from './utils';

import type { FC } from 'react';

export type ContactType = 'primary' | 'secondary';

export interface IContactTypeProps {
  patientGuid: string;
  onChange: (value: ContactType) => void;
  value: ContactType;
}

export const ContactTypeSelect: FC<IContactTypeProps> = ({
  patientGuid,
  onChange,
  value,
}) => {
  const { patientInfo } = usePatientInfo({ patientGuid });

  const options = getContactOptions(patientInfo);
  const selectedOption = options.find((option) => option.value === value);

  return (
    <BaseSelect
      allowClear={false}
      id="contact_type"
      options={options}
      onChange={(option) => {
        const newValue = Array.isArray(option) ? option[0].value : option.value;

        if (newValue === 'primary') {
          onChange('primary');
        } else {
          onChange('secondary');
        }
      }}
      value={selectedOption}
    />
  );
};
